import { useEffect, useState } from 'react';

import { unwrapResult } from '@reduxjs/toolkit';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import { useDispatch, useSelector } from 'react-redux';

import { Pagination } from '../../components/Pagination';

import { OperatorForm } from './forms/OperatorForm';

import {
  createOperator,
  deleteOperator,
  fetchListOperator,
  selectOperatorEntity,
} from './operatorSlice';

export function Operator() {
  const dispatch = useDispatch();
  const operator = useSelector(selectOperatorEntity);
  const [alert, setAlert] = useState(null);
  const [page, setPage] = useState(1);

  useEffect(() => {
    dispatch(fetchListOperator({ page }));
  }, [dispatch, page]);

  return (
    <Row>
      <Col>
        <h4>Danh Sách Khách Hàng</h4>
        <hr />
        <Table bordered responsive size="sm">
          <thead>
            <tr>
              <th>ID</th>
              <th>Email</th>
              <th>Tên</th>
              <th>Thao Tác</th>
            </tr>
          </thead>
          <tbody>
            {operator.ids.map((id) => (
              <tr key={id}>
                <td>{id}</td>
                <td>{operator.entities[id].email}</td>
                <td>{operator.entities[id].name}</td>
                <td>
                  <Button
                    size="sm"
                    variant="danger"
                    onClick={() => {
                      dispatch(
                        deleteOperator({
                          id,
                          email: operator.entities[id].email,
                        })
                      );
                    }}
                  >
                    Xóa
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Pagination
          currentPage={page}
          totalItem={operator.total}
          onPageChange={(page) => setPage(page)}
        />
      </Col>
      <Col md={3}>
        <h4>Tạo Operator</h4>
        <hr />
        <OperatorForm
          alert={
            alert && <Alert variant={alert.variant}>{alert.content}</Alert>
          }
          onSubmit={async (data, e) => {
            setAlert(null);

            try {
              const result = await dispatch(createOperator(data));

              unwrapResult(result);
              setAlert({ variant: 'success', content: 'Thành công!' });
              e.target.reset();
            } catch (e) {
              setAlert({ variant: 'danger', content: e.message });
            }
          }}
        />
      </Col>
    </Row>
  );
}
